/* eslint-disable no-nested-ternary */
import React, { useState, useEffect, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Card, Modal, Loader } from 'sa-ui';
import { injectIntl } from 'react-intl';
import { Row, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { withRouter } from 'react-router-dom';
import { decodeText } from 'app/utils/strings';

import messages from './reportsMessages';
import Scale from './Scale';
import LoadMore from './LoadMore';
import * as helpers from './reportHelpers';

import './PerformanceStudentsComparative.scss';
import StudentPerformanceSquare from './StudentPerformanceSquare';
import { promisify } from '../app/actions';

import * as detailsActions from './application-detail/reportApplicationDetailsActions';
import * as detailsActionsTRI from './general-panel-tri/reportGeneralPanelTRIActions';

function parseMedia(text) {
  return text ? text.replace(/\/cp\/cpdata\/uploads/g, process.env.REACT_APP_FILES_API) : '';
}

const PerformanceStudentsComparative = (props) => {
  const [gradeLimit, setGradeLimit] = useState(props.expanded ? Infinity : props.limit);
  const [showModal, setShowModal] = useState(false);
  const [percentHitsAux, setPercentHitsAux] = useState(0);
  const [loading, setLoading] = useState(false);
  const [noteBook, setNoteBook] = useState('1');
  const [schoolFilter, setSchoolFilter] = useState('');
  const schoolName = props.school ? props.school.name : '';
  const name = props.itens.groupName ? props.itens.groupName : schoolName;

  let itens = [];
  if (props.itens.students) {
    itens = props.itens.students;
  } else if (props.itens.abilities) {
    itens = props.itens.abilities;
  } else {
    itens = props.itens;
  }

  // const gradeScale = props.gradeScale ? props.gradeScale : false;

  async function handleShowModal(idQuestion, percentHits) {
    setLoading(true);
    try {
      await props.getESQuestionDetail({
        idEvaluation: props.idEvaluation,
        idQuestion,
        percentHits: percentHits.toString(),
        idCSchool: props.filter.idCSchool,
        idESCourse: props.filter.idESCourse,
      });
    } finally {
      setPercentHitsAux(percentHits);
      setShowModal(true);
      setLoading(false);
    }
  }
  async function handleShowModalTRI(idQuestion, percentHits, idEvaluation) {
    setLoading(true);
    try {
      await props.getQuestionsDetailTRI({
        idEvaluation: idEvaluation || props.filter.idEvaluation,
        idQuestion,
        percentHits: percentHits.toString(),
        idCSchool: props.filter.idCSchool,
        idESCourse: props.filter.idESCourse,
      });
    } finally {
      setPercentHitsAux(percentHits);
      setShowModal(true);
      setLoading(false);
    }
  }

  useEffect(() => {
    if (props.filterHeatMap && props.filterHeatMap.length > 0) {
      setSchoolFilter(props.filterHeatMap[0]);
    }
  }, [props.filterHeatMap]);

  return (
    <div>
      <Loader show={loading} />
      <Card className="performance-students-comparative">
        <div>
          <h5 className="title mt-0">
            <i className="ti ti-stats-up mr-2" />
            {props.title}
          </h5>
        </div>
        <hr />
        <div className="header">
          <div className="contract-info">
            {name && (
              <span>
                <div className="contract-logo">{helpers.getInitials(name)}</div>
                <span className="contract-name">{name}</span>
              </span>
            )}
          </div>
          <div style={{ maxWidth: 300 }}>
            {props.isTRI ? <Scale gradeScale={{ min: '0', max: '1000' }} /> : <Scale />}
          </div>
        </div>
        {props.tabs ? (
          <div>
            <div>
              <button
                className={`tabButton ${noteBook.toString() === '1' && 'active'}`}
                onClick={() => setNoteBook('1')}
              >
                {`${props.intl.formatMessage(messages.notebook)} 1`}
              </button>
              <button
                className={`tabButton ${noteBook.toString() === '2' && 'active'}`}
                onClick={() => setNoteBook('2')}
              >
                {`${props.intl.formatMessage(messages.notebook)} 2`}
              </button>
            </div>
            <Row>
              {itens
                .filter((s) => s.Evaluation.toString() === noteBook)
                .slice(0, gradeLimit)
                .map((s, index) => (
                  <Col className="mt-3 performance-square--column" style={props.squareSize}>
                    <StudentPerformanceSquare
                      {...s}
                      color={
                        s.canceled
                          ? '#555555'
                          : props.isTRI
                          ? helpers.getColorTRI(s.percentGrade || s.percentHits || s.avg || 0)
                          : helpers.getColor(s.percentGrade || s.percentHits || s.avg || 0)
                      }
                      size={props.size}
                      onClick={() =>
                        s.idQuestion && !props.notClickable && !props.TRI
                          ? handleShowModal(s.idQuestion, s.percentHits)
                          : props.TRI && !props.notClickable
                          ? handleShowModalTRI(s.idQuestion, s.percentHits, s.idEvaluation)
                          : ''
                      }
                      isTRI={props.isTRI}
                      notClickable={props.notClickable}
                    />
                  </Col>
                ))}
            </Row>
          </div>
        ) : props.tabsHeatMap ? (
          <div>
            <div>
              {props.filterHeatMap.map((el) => (
                <button
                  type="button"
                  className={`tabButton ${schoolFilter === el && 'active'}`}
                  onClick={() => setSchoolFilter(el)}
                >
                  {el}
                </button>
              ))}
            </div>
            <Row>
              {itens
                .filter((s) => s.groupName === schoolFilter)
                .slice(0, gradeLimit)
                .map((s, index) => (
                  <Col className="mt-3 performance-square--column" style={props.squareSize}>
                    <StudentPerformanceSquare
                      {...s}
                      color={
                        s.canceled
                          ? '#555555'
                          : props.isTRI
                          ? helpers.getColorTRI(s.percentGrade || s.percentHits || s.avg || 0)
                          : helpers.getColor(s.percentGrade || s.percentHits || s.avg || 0)
                      }
                      size={props.size}
                      onClick={() =>
                        s.idQuestion && !props.notClickable && !props.TRI
                          ? handleShowModal(s.idQuestion, s.percentHits)
                          : props.TRI && !props.notClickable
                          ? handleShowModalTRI(s.idQuestion, s.percentHits, s.idEvaluation)
                          : ''
                      }
                      isTRI={props.isTRI}
                    />
                  </Col>
                ))}
            </Row>
          </div>
        ) : (
          <Row>
            {itens.slice(0, gradeLimit).map((s, index) => (
              <Col className="mt-3 performance-square--column" style={props.squareSize}>
                <StudentPerformanceSquare
                  {...s}
                  color={
                    s.canceled
                      ? '#555555'
                      : props.isTRI
                      ? helpers.getColorTRI(s.percentGrade || s.percentHits || s.avg || 0)
                      : helpers.getColor(s.percentGrade || s.percentHits || s.avg || 0)
                  }
                  size={props.size}
                  onClick={() =>
                    s.idQuestion && !props.notClickable && !props.TRI
                      ? handleShowModal(s.idQuestion, s.percentHits)
                      : props.TRI && !props.notClickable
                      ? handleShowModalTRI(s.idQuestion, s.percentHits, s.idEvaluation)
                      : ''
                  }
                  isTRI={props.isTRI}
                />
              </Col>
            ))}
          </Row>
        )}
        {!props.expanded && itens && gradeLimit < itens.length ? (
          <LoadMore onClick={() => setGradeLimit(gradeLimit + props.limit)} />
        ) : (
          ''
        )}
      </Card>
      {!props.TRI ? (
        <Modal
          show={showModal}
          onClose={() => setShowModal(false)}
          title={props.intl.formatMessage(messages.questionDetail)}
          medium
        >
          {Object.keys(props.questionDetail).length > 0 ? (
            <div style={{ textAlign: 'left' }}>
              <br />
              <div className="d-flex align-items-center mb-3">
                <div className="scale scale-large" style={{ width: '50px' }}>
                  <div
                    className="scale-step step-18"
                    style={{ backgroundColor: helpers.getColor(percentHitsAux) }}
                  >
                    <div className="content">{percentHitsAux}%</div>
                  </div>
                </div>
                <strong className="ml-3">
                  {`${props.intl.formatMessage(messages.question)} ${
                    props.questionDetail.position
                  }`}
                </strong>
              </div>
              <div className="row">
                <div className="col-lg-6 border-right">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: parseMedia(decodeText(props.questionDetail.text)),
                    }}
                    className="fixText"
                  />
                  {props.questionDetail.alternatives.map((a) => (
                    <div
                      className={a.correct === '1' ? 'success fixAlternative' : 'fixAlternative'}
                    >
                      {a.letter.toLowerCase()})
                      <span
                        className="marginAlternative"
                        dangerouslySetInnerHTML={{ __html: parseMedia(decodeText(a.text)) }}
                      />
                    </div>
                  ))}
                </div>
                {/* <hr /> */}
                <div className="col-lg-6">
                  <p>
                    <strong>
                      {`${props.intl.formatMessage(messages.correctAlternative)}: `}
                      {props.questionDetail.alternatives.map((a) =>
                        a.correct === '1' ? a.letter : '',
                      )}
                    </strong>
                  </p>
                  {props.questionDetail.alternatives.map((a) =>
                    a.correct === '1' &&
                    a.feedback !== '' &&
                    parseMedia(decodeText(a.feedback)) !== '<p>&nbsp;</p>' ? (
                      <div>
                        <p>
                          <strong>
                            {`${props.intl.formatMessage(messages.commentedResolution)}: `}
                          </strong>
                        </p>
                        <p>
                          <span
                            dangerouslySetInnerHTML={{ __html: parseMedia(decodeText(a.feedback)) }}
                            className="small"
                          />
                        </p>
                      </div>
                    ) : (
                      ''
                    ),
                  )}
                  <hr />
                  <div className="row">
                    <div className="col-4" style={{ fontSize: '12px' }}>
                      <p>
                        <strong>{`${props.intl.formatMessage(messages.cognitiveLevel)}: `}</strong>
                        <br />
                        <span>{props.questionDetail.blooms.map((b) => b)}</span>
                      </p>
                    </div>
                    <div className="col-8" style={{ fontSize: '12px' }}>
                      <p>
                        <strong>{`${props.intl.formatMessage(messages.ability)}: `}</strong>
                        <br />
                        <strong>
                          <span>{props.questionDetail.abilities.map((a) => a.abilityTitle)}</span>
                        </strong>
                      </p>
                      <p className="font-italic">
                        {props.questionDetail.abilities.map((a) => a.abilityText)}
                      </p>
                    </div>
                  </div>
                  <hr />
                  <table className="table table-bordered">
                    <thead className="text-center">
                      <tr>
                        <th width="20%">{props.intl.formatMessage(messages.alternatives)}</th>
                        <th>{props.intl.formatMessage(messages.percentegaOfChoice)}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {props.questionDetail.alternatives.map((a) => (
                        <tr>
                          <td className="align-middle">{a.letter}</td>
                          <td className="align-middle pl-0">
                            <div className="progress-wrapper border-left border-secondary">
                              <div className="progress bg-white rounded-0">
                                <div
                                  className="progress-bar rounded-right"
                                  style={{
                                    width: a.percentChoose,
                                    backgroundColor: a.correct === '1' ? '#0DD698' : '#E1E0E0',
                                  }}
                                />
                                <span
                                  style={{
                                    color: a.correct === '1' ? '#0DD698' : '#9A9A9A',
                                    marginLeft: '5px',
                                  }}
                                >
                                  {a.percentChoose}%
                                </span>
                              </div>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <p>
                    <strong>
                      {`${props.intl.formatMessage(messages.analysisOfDistractors)}: `}
                    </strong>
                  </p>
                  {props.questionDetail.alternatives.map((a) =>
                    a.correct !== '1' ? (
                      <p className="small">
                        <strong>
                          {`${props.intl.formatMessage(messages.alternative)} ${a.letter}: `}
                        </strong>
                        <span
                          dangerouslySetInnerHTML={{ __html: parseMedia(decodeText(a.feedback)) }}
                        />
                      </p>
                    ) : (
                      ''
                    ),
                  )}
                </div>
              </div>
            </div>
          ) : (
            ''
          )}
        </Modal>
      ) : props.TRI ? (
        <Modal
          show={showModal}
          onClose={() => setShowModal(false)}
          title={props.intl.formatMessage(messages.questionDetail)}
          medium
        >
          {Object.keys(props.questionDetailTRI).length > 0 ? (
            <div style={{ textAlign: 'left' }}>
              <br />
              <div className="d-flex align-items-center mb-3">
                <div className="scale scale-large" style={{ width: '50px' }}>
                  <div
                    className="scale-step step-18"
                    style={{ backgroundColor: helpers.getColor(percentHitsAux) }}
                  >
                    <div className="content">{percentHitsAux}%</div>
                  </div>
                </div>
                <strong className="ml-3">
                  {`${props.intl.formatMessage(messages.question)} ${
                    props.questionDetailTRI.position
                  }`}
                </strong>
              </div>
              <div className="row">
                <div className="col-lg-6 border-right">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: parseMedia(decodeText(props.questionDetailTRI.text)),
                    }}
                    className="fixText"
                  />
                  {props.questionDetailTRI.alternatives.map((a) => (
                    <div
                      className={a.correct === '1' ? 'success fixAlternative' : 'fixAlternative'}
                    >
                      {a.letter.toLowerCase()})
                      <span
                        className="marginAlternative"
                        dangerouslySetInnerHTML={{ __html: parseMedia(decodeText(a.text)) }}
                      />
                    </div>
                  ))}
                </div>
                {/* <hr /> */}
                <div className="col-lg-6">
                  <p>
                    <strong>
                      {`${props.intl.formatMessage(messages.correctAlternative)}: `}
                      {props.questionDetailTRI.alternatives.map((a) =>
                        a.correct === '1' ? a.letter : '',
                      )}
                    </strong>
                  </p>
                  {props.questionDetailTRI.alternatives.map((a) =>
                    a.correct === '1' &&
                    a.feedback !== '' &&
                    parseMedia(decodeText(a.feedback)) !== '<p>&nbsp;</p>' ? (
                      <div>
                        <p>
                          <strong>
                            {`${props.intl.formatMessage(messages.commentedResolution)}: `}
                          </strong>
                        </p>
                        <p>
                          <span
                            dangerouslySetInnerHTML={{ __html: parseMedia(decodeText(a.feedback)) }}
                            className="small"
                          />
                        </p>
                      </div>
                    ) : (
                      ''
                    ),
                  )}
                  <hr />
                  <div className="row">
                    <div className="col-8" style={{ fontSize: '12px' }}>
                      <p>
                        <strong>{`${props.intl.formatMessage(messages.ability)}: `}</strong>
                        <br />
                        <strong>
                          <span>
                            {props.questionDetailTRI.abilities.map((a) => a.abilityTitle)}
                          </span>
                        </strong>
                      </p>
                      <p className="font-italic">
                        {props.questionDetailTRI.abilities.map((a) => a.abilityText)}
                      </p>
                    </div>
                  </div>
                  <hr />
                  <table className="table table-bordered">
                    <thead className="text-center">
                      <tr>
                        <th width="20%">{props.intl.formatMessage(messages.alternatives)}</th>
                        <th>{props.intl.formatMessage(messages.percentegaOfChoice)}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {props.questionDetailTRI.alternatives.map((a) => (
                        <tr>
                          <td className="align-middle">{a.letter}</td>
                          <td className="align-middle pl-0">
                            <div className="progress-wrapper border-left border-secondary">
                              <div className="progress bg-white rounded-0">
                                <div
                                  className="progress-bar rounded-right"
                                  style={{
                                    width: a.percentChoose,
                                    backgroundColor: a.correct === '1' ? '#0DD698' : '#E1E0E0',
                                  }}
                                />
                                <span
                                  style={{
                                    color: a.correct === '1' ? '#0DD698' : '#9A9A9A',
                                    marginLeft: '5px',
                                  }}
                                >
                                  {a.percentChoose}%
                                </span>
                              </div>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <p>
                    <strong>
                      {`${props.intl.formatMessage(messages.analysisOfDistractors)}: `}
                    </strong>
                  </p>
                  {props.questionDetailTRI.alternatives.map((a) =>
                    a.correct !== '1' ? (
                      <p className="small">
                        <strong>
                          {`${props.intl.formatMessage(messages.alternative)} ${a.letter}: `}
                        </strong>
                        <span
                          dangerouslySetInnerHTML={{ __html: parseMedia(decodeText(a.feedback)) }}
                        />
                      </p>
                    ) : (
                      ''
                    ),
                  )}
                </div>
              </div>
            </div>
          ) : (
            ''
          )}
        </Modal>
      ) : (
        ''
      )}
    </div>
  );
};
PerformanceStudentsComparative.propTypes = {};

PerformanceStudentsComparative.defaultProps = {
  itens: [],
  expanded: false,
  limit: 24,
};

const mapStateToProps = ({ reportApplicationDetails, reportGeneralTRIPanel }) => ({
  ...reportApplicationDetails,
  ...reportGeneralTRIPanel,
});
/*
const mapStateToProps2 = ({ reportGeneralPanelTRI }) => ({
  ...reportGeneralPanelTRI,
}); */
export default compose(
  injectIntl,
  withRouter,
  connect(mapStateToProps, promisify({ ...detailsActions, ...detailsActionsTRI })),
)(PerformanceStudentsComparative);
